export default {
  GET_ALL: `#graphql
  query getLabels($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getLabels(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        label,
        width,
        height,
        quantity,
        containerWidth,
        padding,
        spaceBetween,
        shapes {
          width,
          height,
          left,
          top
        }
        strings {
          width,
          height,
          left,
          top,
          text,
          testText,
          bold,
          degrees
        }
        codes {
          width,
          height,
          heightText,
          left,
          top,
          text,
          testText,
          degrees
        }
        qrcodes {
          width,
          height,
          heightText,
          left,
          top,
          text,
          testText,
          degrees
        }
        images {
          width,
          height,
          left,
          top,
          folder,
          name,
          degrees
        }
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getLabelsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getLabelsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        label,
        width,
        height,
        quantity,
        containerWidth,
        padding,
        spaceBetween,
        shapes {
          width,
          height,
          left,
          top
        }
        strings {
          width,
          height,
          left,
          top,
          text,
          testText,
          bold,
          degrees
        }
        codes {
          width,
          height,
          heightText,
          left,
          top,
          text,
          testText,
          degrees
        }
        qrcodes {
          width,
          height,
          heightText,
          left,
          top,
          text,
          testText,
          degrees
        }
        images {
          width,
          height,
          left,
          top,
          folder,
          name,
          degrees
        },
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewLabel($label: LabelInput!) {
    newLabel(input: $label)
    {
      label,
      width,
      height,
      quantity,
      containerWidth,
      padding,
      spaceBetween,
      shapes {
        width,
        height,
        left,
        top
      }
      strings {
        width,
        height,
        left,
        top,
        text,
        testText,
        bold,
        degrees
      }
      codes {
        width,
        height,
        heightText,
        left,
        top,
        text,
        testText,
        degrees
      }
      qrcodes {
        width,
        height,
        heightText,
        left,
        top,
        text,
        testText,
        degrees
      }
      images {
        width,
        height,
        left,
        top,
        folder,
        name,
        degrees
      }
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateLabel($label: String!, $labelUpdate: LabelUpdateInput!) {
    updateLabel(label:$label, labelUpdate: $labelUpdate)
    {
      label
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteLabel($label: String!) {
    deleteLabel(label:$label)
    {
      label
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/label.js